import React from "react";
import {isEmpty} from "weed-js";
import Loading from "../elements/Loading";

export const TableBody = ({
    compact,
    data,
    isLoading,
    offset,
    pageSize,
    collapsed,
    view,
    noDataMessage = "No data available.",
}) => {

    const nColumns = view.getActiveColumnDefs().length;

    if (isLoading) {
        return <tbody className={"canold-table-body"}>
            <tr role={"row"}>
                <td role="cell" colSpan={nColumns} className="canold-table-loading">
                    <Loading fullscreen={true}/>
                </td>
            </tr>
        </tbody>;
    }

    if (isEmpty(data) || isEmpty(view.getActiveColumnDefs())) {
        return <tbody className={"canold-table-body"}>
            <tr role={"row"}>
                <td role="cell" colSpan={nColumns} className="canold-table-empty">{noDataMessage}</td>
            </tr>
        </tbody>;
    }


    return <tbody role={"canold-table-body"} className={"canold-table-body"}>
        {data.slice(offset, offset + pageSize).map((row) => {
            return row.render(compact, view.getActiveColumnDefs(), collapsed);
        })}
    </tbody>;
};
